import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en.json';

i18next.addResourceBundle('en', 'direction', en);

const DirectionListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Directions',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.DIRECTION,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/direction/list',
      component: React.lazy(() => import('./DirectionList')),
    },
  ],
};

export default DirectionListConfig;
